<template>
  <BaseInlineNotification
    v-if="submitCount > 0 && !isEmpty(errors)"
    :id="id"
    :focus-on-mounted="!isEmpty(errors)"
    :heading-text="headingText"
    :title-element="titleElement"
    :title-id="titleId"
    type="error"
  >
    <ol class="flex list-decimal flex-col gap-2 pl-5">
      <li
        v-for="(error, key) in errors"
        :key="key"
        class="body-sm text-gray-800"
      >
        <!-- It's important that the form input ID matches the error key. -->
        <a
          :href="`#${key}`"
          class="wc-focus rounded-xs underline hover:text-gray-950"
        >
          <span v-text="`${startCase(key as string)}: `" />
          <span v-text="error" />
        </a>
      </li>
    </ol>
  </BaseInlineNotification>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import isEmpty from 'lodash.isempty'
import startCase from 'lodash.startcase'

import BaseInlineNotification from '@js/components/global/BaseInlineNotification.vue'

defineOptions({
  name: 'BaseFormErrorSummary',
})

const props = withDefaults(
  defineProps<{
    id?: string
    titleId?: string
    submitCount: number
    titleElement?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
    errors: Record<string, string | undefined>
  }>(),
  {
    titleElement: 'h2',
    id: 'error-summary',
    titleId: 'error-summary-title',
  },
)

const headingText = computed(() => {
  const errorCount = Object.keys(props.errors).length

  return `There ${errorCount === 1 ? 'was' : 'were'} ${errorCount} ${errorCount === 1 ? 'error' : 'errors'} found in the information you submitted.`
})
</script>
